import Linkify from 'react-linkify'
import DOMPurify from 'dompurify'
import { SecureLink } from 'react-secure-link'

const AnnouncementBubble = ({ title, message }) => {
  const formattedMsg = slackLinkToText(message)
  const safeMsg = DOMPurify.sanitize(formattedMsg)

  return (
    <div className="p-3.5 rounded-xl bg-primary/[0.08] mb-4">
      <h1 className="text-primary font-medium">{title}</h1>
      <div className="text-dark/50 text-sm mt-4 mb-2 child-highlight whitespace-pre-line">
        <p>
        <Linkify
          componentDecorator={(decoratedHref, decoratedText, key) => (
            <SecureLink href={decoratedHref} key={key}>
              {decoratedText.length>25?'link':decoratedText}
            </SecureLink>
          )}
        >
          {safeMsg}
        </Linkify>
        </p>
      </div>
    </div>
  )
}

const slackLinkToText = (message) => {
  while (message.match(/<(.*?)\|/)) {
    let link = message.match(/\/\/(.*?)\|/)[1]
    let tag = message.match(/<(.*?)>/g)[0]
    message = message.replace(tag, link)
  }
  return message
}

export default AnnouncementBubble
